import React from 'react';
import styles from './AboutUs.module.css';

export default function AboutUs() {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>My AI Agent</h1>
      
      <p>My AI Agent was created with one mission: help small businesses never lose another lead again. We know that most service-based businesses rely on phone calls — and every missed call can mean missed revenue. But owners are busy, in the field, with customers, or simply unable to answer every time the phone rings.</p>
      
      <p>That's why we built a simple, powerful, fully automated solution that works behind the scenes to keep your business connected, responsive, and always "open."</p>
      
      <h2 className={styles.heading}>Our Vision</h2>
      <p>To give small businesses the communication superpowers that big companies have — without complexity, cost, or technical headaches.</p>
      
      <h2 className={styles.heading}>What We Do</h2>
      <p>We combine:</p>
      <ul className={styles.list}>
        <li>Missed Call Text-Back</li>
        <li>AI lead response</li>
        <li>Appointment scheduling</li>
        <li>Smart automation</li>
        <li>CRM integration</li>
      </ul>
      <p>All delivered through a cloud-based platform that works with your existing phone number, your existing systems, and your existing workflow.</p>
      
      <h2 className={styles.heading}>Why It Matters</h2>
      <p>When customers reach out, they expect instant communication. With My AI Agent, you never leave anyone waiting. Your AI responds within seconds, answers questions, collects details, and even books appointments — all automatically.</p>
      
      <h2 className={styles.heading}>Who We Serve</h2>
      <p>We proudly support:</p>
      <ul className={styles.list}>
        <li>Home service providers</li>
        <li>Medical & dental practices</li>
        <li>Real estate professionals</li>
        <li>Automotive businesses</li>
        <li>Salons & beauty professionals</li>
        <li>Local service businesses of all kinds</li>
      </ul>
      <p>If you receive leads by phone, My AI Agent helps you capture more of them — effortlessly.</p>
      
      <h2 className={styles.heading}>Our Commitment</h2>
      <p>We believe technology should work for you, not slow you down. That's why our platform is:</p>
      <ul className={styles.list}>
        <li>Easy to use</li>
        <li>Secure</li>
        <li>Affordable</li>
        <li>Contract-free</li>
        <li>Built to deliver real results from day one</li>
      </ul>
      
      <p>At My AI Agent, we're here to help your business grow — one conversation at a time.</p>
    </div>
  );
}